export const GET_USERS = 'GET_USERS';
export const GET_USER = 'GET_USER';
export const USER_ERROR = 'USER_ERROR';
